import * as React from 'react';
import styled from 'styled-components';
import { neutralColors } from '../../styles/colors/colors.js';
import { spacing3x } from '../../styles/spacing.js';
import { IconArrowRight } from '../Icons/IconArrowRight.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var StyledLi = styled.li.withConfig({
  displayName: "BreadcrumbItemBase__StyledLi",
  componentId: "sc-ha2d1f-0"
})(["&&{display:inline-flex;align-items:center;min-width:62px;flex:", ";}&& *::after{content:'';display:block;}"], function (props) {
  if (props.isFirst) return "none";
  if (props.isLast) return "1 2 auto";
  return "0 3 auto";
});
var BreadcrumbItemBase = /*#__PURE__*/React.forwardRef(function BreadcrumbItemBase2(_ref, ref) {
  var children = _ref.children,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast;
  return /*#__PURE__*/jsxs(StyledLi, {
    ref: ref,
    isLast: isLast,
    isFirst: isFirst,
    children: [children, !isLast && /*#__PURE__*/jsx(IconArrowRight, {
      size: 16,
      color: neutralColors.smoke,
      style: {
        margin: "0px ".concat(spacing3x)
      }
    })]
  });
});
BreadcrumbItemBase.displayName = "BreadcrumbItemBase";

export { BreadcrumbItemBase };
